import React from "react";
import { Card, Box } from "@mui/material";
import SMButtonWhite from "../../navigation/SMButtonWhite";

export default function ProductVerticalCard({
                                                bgColor = "#8A7366",
                                                imageSrc,
                                                imageAlt = "",
                                                buttonLabel = "BEANS",

                                                // navigation / action
                                                to, // <-- NEW
                                                onButtonClick, // optional fallback if no `to`

                                                // decoration
                                                decorationSrc,
                                                decorationSize = "120%",
                                                decorationOpacity = 0.10,
                                                decorationVariant = "tl-br",

                                                cardSx,
                                                imageSx,
                                                buttonSx,
                                                children,
                                            }) {
    const isTLBR = decorationVariant === "tl-br";

    const hasTo = Boolean(to);
    const buttonProps = hasTo
        ? { to }
        : { onClick: onButtonClick };

    return (
        <Card
            elevation={0}
            sx={{
                position: "relative",
                overflow: "hidden",
                width: "100%",
                borderRadius: 5,
                bgcolor: bgColor,
                p: 2,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                ...cardSx,
            }}
        >
            {/* Decorations */}
            {decorationSrc && (
                <>
                    <Box
                        component="img"
                        src={decorationSrc}
                        alt=""
                        aria-hidden
                        sx={{
                            position: "absolute",
                            top: isTLBR ? { xs: -250, sm: -380, md: -280, lg: -200, xl: -280 } : "auto",
                            bottom: isTLBR ? "auto" : { xs: -250, sm: -380, md: -280, lg: -180, xl: -250 },
                            left: isTLBR ? { xs: -350, sm: -580, md: -380, lg: -310, xl: -420 } : "auto",
                            right: isTLBR ? "auto" : { xs: 280, sm: 580, md: 320, lg: 240, xl: 320 },
                            width: { xs: decorationSize, sm: "105%", md: "110%", lg: decorationSize },
                            opacity: decorationOpacity,
                            pointerEvents: "none",
                            transform: "rotate(90deg)",
                            transformOrigin: "center",
                        }}
                    />
                    <Box
                        component="img"
                        src={decorationSrc}
                        alt=""
                        aria-hidden
                        sx={{
                            position: "absolute",
                            top: isTLBR ? "auto" : { xs: -250, sm: -380, md: -280, lg: -200, xl: -280 },
                            bottom: isTLBR ? { xs: -250, sm: -380, md: -280, lg: -180, xl: -250 } : "auto",
                            right: isTLBR ? { xs: -350, sm: -580, md: -380, lg: -310, xl: -420 } : "auto",
                            left: isTLBR ? "auto" : { xs: 280, sm: 580, md: 320, lg: 250, xl: 320 },
                            width: { xs: decorationSize, sm: "105%", md: "110%", lg: decorationSize },
                            opacity: decorationOpacity,
                            pointerEvents: "none",
                            transform: "rotate(-90deg)",
                            transformOrigin: "center",
                        }}
                    />
                </>
            )}

            {/* Product Image */}
            <Box
                sx={{
                    width: "100%",
                    aspectRatio: "1 / 1",
                    borderRadius: 4,
                    overflow: "hidden",
                    position: "relative",
                    zIndex: 1,
                    ...imageSx,
                }}
            >
                <Box
                    component="img"
                    src={imageSrc}
                    alt={imageAlt}
                    loading="lazy"
                    sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                    }}
                />
            </Box>

            {children && (
                <Box sx={{ position: "relative", zIndex: 1 }}>
                    {children}
                </Box>
            )}

            {/* Button */}
            <Box sx={{ textAlign: 'center', ...buttonSx }}>
                <SMButtonWhite {...buttonProps} sx={{
                    width: { xs: "90%", md: "80%"},
                }}>
                    {buttonLabel}
                </SMButtonWhite>
            </Box>
        </Card>
    );
}